export default "__VITE_ASSET__CaWsVZBx__"